export const BLOCKS_LAYOUT = 'blocks';
export const BIG_BLOCK_LAYOUT = 'big-block';
